/*
  Open the slide-out cart drawer whenever something is added to the cart,
  instead of redirecting to /cart or doing nothing.

  This store adds to cart in several ways:
    - PDP custom "chicken-cart-form": a plain <form> that submits natively.
    - PageFly / shoppable-video buttons: JS that POSTs to /cart/add.js (no
      native submit event fires).
  So we cover BOTH:
    1) Intercept native form submits to /cart/add -> AJAX add (prevents redirect).
    2) Intercept fetch/XHR to /cart/add (app-driven) and open the drawer after.
  Any successful /cart/add re-renders + opens the drawer. "Buy now" buttons
  (checkout) are left alone. Native <product-form> forms keep the theme's flow.
*/
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  // Re-render the drawer from the server (reflects the new cart) and open it.
  var lock = false;
  function openDrawerAfterAdd() {
    var drawer = getDrawer();
    if (!drawer || lock) return;
    lock = true;
    fetch(root + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        // El innerHTML nuevo trae un overlay sin listener: sin esto, tocar el
        // fondo gris no cierra el carrito despues de agregar.
        var overlay = cur && cur.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.addEventListener('click', function () {
            if (typeof drawer.close === 'function') drawer.close();
            else drawer.classList.remove('active');
          });
        }
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('active');
      })
      .catch(function () {})
      .then(function () {
        setTimeout(function () {
          lock = false;
        }, 350);
      });
  }

  // 1) Native form submits (plain forms that would otherwise reload to /cart)
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      if (form.closest('product-form')) return; // theme handles these natively

      // Leave "Buy now / Comprar ahora" (checkout) buttons alone
      var submitter = e.submitter;
      if (submitter) {
        var fa = submitter.getAttribute('formaction') || '';
        if (submitter.name === 'checkout' || /checkout/i.test(fa)) return;
      }
      if (!getDrawer()) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var fd = new FormData(form, submitter);
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res && (res.status === 422 || res.status === 'bad_request')) {
            form.submit(); // surface the error via the normal flow
            return;
          }
          openDrawerAfterAdd();
        })
        .catch(function () {
          form.submit();
        });
    },
    true
  );

  // 2) App / JS-driven adds via fetch
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var p = origFetch.apply(this, arguments);
      if (isAddUrl(url) && !/checkout=true/i.test(String(url))) {
        p.then(function (resp) {
          if (!resp || resp.status === undefined || (resp.status >= 200 && resp.status < 300)) {
            setTimeout(openDrawerAfterAdd, 90);
          }
        }).catch(function () {});
      }
      return p;
    };
  }

  // 3) App / JS-driven adds via XMLHttpRequest
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isAdd = isAddUrl(url) && !/checkout=true/i.test(String(url));
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__isAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) setTimeout(openDrawerAfterAdd, 90);
        });
      }
      return origSend.apply(this, arguments);
    };
  }
})();
